import React, {useEffect, useRef, useState} from 'react';
import {useDispatch, useSelector} from "react-redux";
import {
    getAlarms,
    getAlarmsLoading,
    getAlarmsPagination,
    getDevices,
    getDeviceTypes,
    getLocation,
    getLocationTableData, getUserInfo,
    installationSelect
} from "../../../redux-store/selectors";
import mapboxgl from "mapbox-gl";
import {Pagination, Select, Table, Tooltip} from "antd";
import alarmIcon from "../../../images/bell.png";
import commandIcon from "../../../images/command-line.png";
import notesIcon from "../../../images/notes.png";
import {Navigate, useNavigate} from "react-router-dom";
import {Card} from "react-bootstrap";
import DeviceHistoryChart from "../../Charts/DeviceHistoryChart";
import {getLocationParametersView, letterSpace, timeStampToTimeString} from "../../../constants/FunctionJS";
import editIcon from "../../../images/Group 28.svg"
import LocationModal from "../../Devices/LocationModal";
import {clearAlarmsHistory, openAlarmsModal, openCommandsModal, openModal, setLocation} from "../../../redux-store/map";
import redIcon from "../../../images/red-icon.png";
import orangeIcon from "../../../images/orange-icon.png";
import blueIcon from "../../../images/blue-icon.png";
import greenIcon from "../../../images/green-icon.png";
import yellowIcon from "../../../images/yellow-icon.png";

import CommandsModal from "./CommandsModal";
import AlarmsModal from "./AlarmsModal";

import {fetchAlarmsByLocationId} from "../../../redux-store/alarms";
import {mapLevelToImage} from "../Alarms/AlarmsTable";
import {fetchDeviceByLocationId, fetchDeviceTypes} from "../../../redux-store/devices";
import {setModalStatus} from "../../../redux-store/notes";
import LocationNotes from "./LocationNotes";
import {checkUserViewer} from "../../authHelpers";

mapboxgl.accessToken = `${process.env["REACT_APP_MAPBOX_TOKEN"]}`;
const {Option} = Select

const alarmsTableHeader = [
    {
        dataIndex: "level",
        key: "id",
        render: (text, record) => {
            return <img src={mapLevelToImage[text]} height={20}/>
            return "";
        },
        width: "5%",
        align: 'center'
    },
    {
        title: <Tooltip title="Opis alarma"><span>Opis alarma</span></Tooltip>,
        dataIndex: "alarmText",
        key: "alarmText",
        render: (text, record) => {
            return <span className={`${record.clearedAt === null ? "fw-bold" : ""}`}>{text}</span>
        }
    },
    {
        title: <Tooltip title="Aktiviran"><span>Aktiviran</span></Tooltip>,
        dataIndex: "triggeredAt",
        key: "triggeredAt",
        render: (text, record) => <span
            className={`${record.clearedAt === null ? "fw-bold" : ""}`}>{timeStampToTimeString(text)}</span>
    },
    {
        title: <Tooltip title="Poništen"><span>Poništen</span></Tooltip>,
        dataIndex: "clearedAt",
        key: "clearedAt",
        render: (text, record) => {
            if (text === null) return "";
            return <span>{timeStampToTimeString(text)}</span>
        }
    },
]

const getLocationData = (location) => {
    let color = "GREEN";
    if (location.level !== null)
        color = location.level;
    return {
        "type": "geojson",
        "data": {
            "type": "FeatureCollection",
            "features": [
                {
                    "type": "Feature",
                    "geometry": {
                        "type": "Point",
                        "coordinates": [location.longitude, location.latitude]
                    },
                    "properties": {
                        "icon": color
                    }
                }
            ]
        }
    }
}
const MapLocationDevices = () => {

        const dispatch = useDispatch();

        const mapContainer = useRef(null);
        const map = useRef(null);

        const location = useSelector(getLocation);
        const installation = useSelector(installationSelect);
        const devices = useSelector(getDevices);
        const deviceTypes = useSelector(getDeviceTypes);
        const userInfo = useSelector(getUserInfo)

        const locationTableData = useSelector(getLocationTableData);

        const alarms = useSelector(getAlarms);
        const alarmsLoading = useSelector(getAlarmsLoading);
        const {total, currentPage, pageSize} = useSelector(getAlarmsPagination);

        const [selectedDevice, setSelectedDevice] = useState(null);
        const [deviceSelectData, setDeviceSelectData] = useState([]);
        const [parameterSelectData, setParameterSelectData] = useState([]);

        const [selectedSelectDevice, setSelectedSelectDevice] = useState(null);
        const [selectedParameters, setSelectedParameters] = useState([]);
        const [online, setOnline] = useState(false);
        const [parametersLIst, setParametersList] = useState([]);

        useEffect(() => {

            if (location === null || installation.value === null)
                return;
            dispatch(fetchDeviceByLocationId({installationId: installation.value, locationId: location.id}));
            dispatch(fetchDeviceTypes());
            dispatch(fetchAlarmsByLocationId({installationId: installation.value, locationId: location.id}))
            if (!mapContainer.current) return;
            map.current = new mapboxgl.Map({
                container: mapContainer.current,
                style: 'mapbox://styles/mapbox/streets-v11',
                center: [location.longitude, location.latitude],
                zoom: 13,
                attributionControl: false
            })
            map.current.on("load", () => {
                map.current.loadImage(redIcon, (error, image) => {
                    map.current.addImage('RED', image, {'sdf': false});
                });
                map.current.loadImage(orangeIcon, (error, image) => {
                    map.current.addImage('ORANGE', image, {'sdf': false});
                });
                map.current.loadImage(blueIcon, (error, image) => {
                    map.current.addImage('BLUE', image, {'sdf': false});
                });
                map.current.loadImage(greenIcon, (error, image) => {
                    map.current.addImage('GREEN', image, {'sdf': false});
                });
                map.current.loadImage(yellowIcon, (error, image) => {
                    map.current.addImage('YELLOW', image, {'sdf': false});
                });

                const data = getLocationData(location);
                map.current.addSource("location", data);
                map.current.addLayer({
                    "id": "location",
                    "type": "symbol",
                    "source": "location",
                    'layout': {
                        'icon-image': ['image', ['get', 'icon']],
                        'icon-size': 0.4,
                        'icon-allow-overlap': true
                    },
                })

            })
            return () => dispatch(clearAlarmsHistory());
        }, [location]);

        useEffect(() => {
            const selectedData = devices.map((item, counter) => {
                if (counter === 0) {
                    handleDeviceSelectChange({label: item.model, value: item.id})
                    setSelectedDevice(item);
                }
                return (<Option value={item.id}>{item.model}</Option>)
            });
            setDeviceSelectData(selectedData);

        }, [devices]);

        useEffect(() => {
            if (selectedSelectDevice === null) return;
            const deviceType = deviceTypes.find(item => item.model === selectedSelectDevice.label);
            if (deviceType === undefined) return;
            const {readableParameters} = deviceType;
            const parameterSelectData = readableParameters.map(item => {
                return (
                    <Option
                        disabled={
                            selectedParameters.length >= 5
                                ? !selectedParameters.includes(item)
                                : false
                        }
                        key={item}
                        value={item}
                    >
                        {item}
                    </Option>
                )
            })
            setParameterSelectData(parameterSelectData);

        }, [selectedSelectDevice, deviceTypes, selectedParameters]);

        useEffect(() => {
            if (locationTableData.length === 0) return;
            const tableData = locationTableData[0];
            const hasData = tableData.columns.length > 0 && tableData.rows[0]?.cells.length > 0;
            const pomData = [];
            if (hasData) {
                const columns = tableData.columns;
                const cells = tableData.rows[0]?.cells;
                columns.forEach((item, counter) => {
                    if (checkUserViewer(userInfo)) {
                        if (item.type === "DATA") {
                            const cell = cells[counter];
                            if (item.parameterName === "online") {
                                setOnline(cell.value);
                            }
                            pomData.push({
                                commandArgs: {
                                    methodName: item?.methodName,
                                    arguments: item?.arguments,
                                    deviceId: cell?.deviceId,
                                },
                                type: item.type,
                                name: cell.parameterName,
                                value: cell.value,
                                title: item.title,
                                pipe: item.pipe,
                                pipeArg: item.pipeArg,
                                description:item.description
                            })
                        }
                    } else {
                        const cell = cells[counter];
                        if (item.parameterName === "online") {
                            setOnline(cell.value);
                        }
                        pomData.push({
                            commandArgs: {
                                methodName: item?.methodName,
                                arguments: item?.arguments,
                                deviceId: cell?.deviceId,
                            },
                            type: item.type,
                            name: cell.parameterName,
                            value: cell.value,
                            title: item.title,
                            pipe: item.pipe,
                            pipeArg: item.pipeArg,
                            description:item.description
                        })
                    }
                })
            }
            setParametersList(pomData)
        }, [locationTableData]);

        const handleDeviceSelectChange = (obj) => {
            setSelectedSelectDevice(obj);
        }

        if (location === null || installation.value === null)
            return <Navigate to="/" state={{from: location}} replace/>

        const getDeviceParameterData = (device) => {
            if (device === null) return <div>No data</div>
            const dataList = [];
            for (let [key, value] of Object.entries(device)) {
                if (typeof value === "boolean") {
                    value = value ? "on" : "off";
                }
                dataList.push(<tr>
                    <td className={"first-letter-uppercase"}>{letterSpace(key)}</td>
                    <td>{value}</td>
                </tr>)
            }
            return dataList.map(item => item)
        }

        const handleDeviceClick = (item) => {
            setSelectedDevice(item);
        }
        const handleParameterSelectChange = value => {
            setSelectedParameters(value)
        }
        const handleLocationEdit = () => {
            dispatch(openModal());
            dispatch(setLocation(location));
        }
        const handleAlarmClick = () => {
            dispatch(openAlarmsModal());
        }

        const handleCommandsClick = () => {
            dispatch(openCommandsModal());
        }
        const handleNotesClick = () => {
            dispatch(setModalStatus(true));
        }
        return (
            <>
                <CommandsModal installationId={installation.value} devices={devices}/>
                <LocationModal installationId={installation.value}/>
                <LocationNotes installationId={installation.value} locationId={location?.id}/>
                <AlarmsModal devices={devices} installationId={installation.value} locationId={location?.id}/>
                <div className={"container pt-4"}>
                    <div className={"row"}>
                        <div className={"col-12 pt-3"}>
                            <label className={"location-title"}>{location.name}</label>
                            <button className={"btn btn-pt-pr"} onClick={handleLocationEdit}><img src={editIcon}/></button>
                            {checkUserViewer(userInfo) ? "" :
                                <button className={"btn btn-alarm btn-pt-pl"} onClick={handleAlarmClick}><img
                                    src={alarmIcon}/>
                                </button>}
                            {checkUserViewer(userInfo) ? "" :
                                <button className={"btn btn-alarm btn-pt-pl"} onClick={handleCommandsClick}><img
                                    src={commandIcon}/></button>}
                            <button className={"btn btn-alarm btn-pt-pl"} onClick={handleNotesClick}><img
                                src={notesIcon}/></button>
                        </div>
                    </div>
                    <div className={"row"}>
                        <div className={"d-flex pt-3"}>
                            <h5 className={"font-bold "}>Lokacija</h5>
                            <div><span
                                className={`${online ? "map-drawer-status-on" : "map-drawer-status-off"}`}>{online ? "ONLINE" : "OFFLINE"}</span>
                            </div>
                        </div>
                        <span className={"location-description"}>{location?.description}</span>
                    </div>
                    <div className={"row"}>
                        <div className={"col-12 col-md-8 col-lg-8 col-xl-8 pb-2"}
                             style={{height: "280px", position: "relative"}}>
                            <div ref={mapContainer} className={"map-container"}></div>
                        </div>
                        <div className={"col-12 col-md-4 col-lg-4 col-xl-4 locatino-info pt-3"}>
                            <h5 className={"font-bold "}>Detalji lokacije</h5>
                            {getLocationParametersView(parametersLIst)}
                        </div>
                    </div>
                    <div className={"row"}>
                        <div className={"col-12 pt-3"}>
                            <h5 className={"font-bold "}>Uređајi</h5>
                        </div>
                    </div>
                    <div className={"row"}>
                        <div className={"col-12 col-md-4 col-lg-4 col-xl-4 pt-1"}>
                            <div className={"device-info"}>
                                {devices.map(item =>
                                    <div onClick={handleDeviceClick.bind(this, item)}
                                         className={`device-model${selectedDevice !== null && selectedDevice.model === item.model ? "-active" : ""}`}>
                                        {item.model}
                                    </div>
                                )}
                            </div>
                        </div>
                        <div className={"col-12 col-md-8 col-lg-8 col-xl-8 pt-1 pr-unset"}>
                            <Card className={"b-unset"}>
                                <Card.Header className={"card-title-location"}>Detalji
                                    uređaja: {selectedDevice !== null ? selectedDevice.model : ""}</Card.Header>
                                <Card.Body className={"card-body-location"}>
                                    <table className="table">
                                        <thead>
                                        <tr>
                                            <th scope="col">Naziv polja</th>
                                            <th scope="col">Vrijednost</th>
                                        </tr>
                                        </thead>
                                        <tbody>
                                        {getDeviceParameterData(selectedDevice)}
                                        </tbody>
                                    </table>
                                </Card.Body>
                            </Card>
                        </div>
                    </div>
                    <div className={"row"}>
                        <div className={"col-12 pt-3"}>
                            <h5 className={"font-bold "}>Alarmi</h5>
                        </div>
                    </div>
                    <div className={"row"}>
                        <div className={"col-12 p-unset"}>
                            <Table showSorterTooltip={false} columns={alarmsTableHeader} dataSource={alarms} size="middle"
                                   scroll={{
                                       x: 900,
                                       y: 450,
                                   }}
                                   loading={alarmsLoading}
                                   pagination={false}
                            />
                            {total !== 0 && <div className={"row text-right pt-2 pb-4"}>
                                <Pagination defaultCurrent={1}
                                            current={currentPage + 1}
                                            total={total}
                                            showSizeChanger={false}
                                            onChange={(newPage, newPageSize) => {
                                                dispatch(fetchAlarmsByLocationId({
                                                    installationId: installation.value,
                                                    locationId: location.id,
                                                    page: newPage - 1,
                                                }));
                                            }}
                                            defaultPageSize={pageSize}
                                />
                            </div>}
                        </div>
                    </div>
                    <div className={"row"}>
                        <div className={"col-12 pt-3"}>
                            <h5 className={"font-bold "}>Istorijski pregled</h5>
                        </div>
                    </div>
                    <div className={"row"}>
                        <div className={"col-12 col-md-6 col-lg-4 col-xl-4 ant-select-installations pb-3 pt-1"}>
                            <Select labelInValue className={"form-select"}
                                    onChange={handleDeviceSelectChange} value={selectedSelectDevice}>
                                {deviceSelectData}
                            </Select>
                        </div>
                        <div className={"col-12 col-md-6 col-lg-4 col-xl-4 ant-select-installations pb-3 pt-1"}>
                            <Select mode="multiple" allowClear className={"form-select"}
                                    onChange={handleParameterSelectChange} value={selectedParameters}>
                                {parameterSelectData}
                            </Select>
                        </div>
                        <div className={"col-12 pr-unset"}>
                            <DeviceHistoryChart deviceId={selectedSelectDevice?.value}
                                                parametersNames={selectedParameters}/>
                        </div>
                    </div>
                </div>
            </>

        );
    }
;

export default MapLocationDevices;